import React from 'react';
import { useTranslation } from 'next-i18next';
import { Menu } from '@mui/material';
import { KeyboardArrowDownRounded } from '@mui/icons-material/';
import ReadSurahSelectorForm from './form';
import { ReadSurah } from '@/infrastructure/class/read-surah';
import s from './styles.module.scss';

interface IReadSurahSelectorProps {
  currentSurah: ReadSurah;
  surahs: ReadSurah[];
  ayasCount: number;
  className?: string;
}

const ReadSurahSelector: React.FC<IReadSurahSelectorProps> = (props) => {
  const { currentSurah, surahs, ayasCount, className = '' } = props;

  const { t: tButtons } = useTranslation('buttons');

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={className}>
      <button className={s['button']} onClick={handleClick}>
        <span>{tButtons('surah')}</span>
        <i>
          <KeyboardArrowDownRounded />
        </i>
      </button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <ReadSurahSelectorForm
          surahs={surahs}
          currentSurah={currentSurah}
          ayasCount={ayasCount}
          onClose={handleClose}
        />
      </Menu>
    </div>
  );
};

export default ReadSurahSelector;
